import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const COOKIE_KEY = "cf_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
    if (consent === "accepted") {
      loadAnalytics();
    }
  }, []);

  const loadAnalytics = () => {
    const gaId = "G-5SVRC2CVHR";
    if (document.getElementById("ga-script")) return;

    const script = document.createElement("script");
    script.id = "ga-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);

    const inline = document.createElement("script");
    inline.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gaId}');
    `;
    document.head.appendChild(inline);
  };

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
    loadAnalytics();
  };

  const decline = () => {
    localStorage.setItem(COOKIE_KEY, "declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 200 }}
          className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6"
          data-testid="cookie-consent-banner"
        >
          <div className="max-w-4xl mx-auto p-5 md:p-6 rounded-2xl bg-[#121212] border border-white/10 shadow-2xl backdrop-blur-xl">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
              <div className="flex-1">
                <h3 className="text-white font-semibold mb-1 text-sm">Cookies & Privacy</h3>
                <p className="text-[#A1A1AA] text-xs leading-relaxed">
                  Wij gebruiken cookies om uw ervaring te verbeteren en websiteverkeer te analyseren.
                  Door op "Accepteren" te klikken, stemt u in met het gebruik van analytische cookies.
                </p>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <button
                  onClick={decline}
                  data-testid="cookie-decline-btn"
                  className="px-4 py-2 rounded-xl text-sm text-[#A1A1AA] hover:text-white bg-white/5 hover:bg-white/10 transition-colors"
                >
                  Weigeren
                </button>
                <button
                  onClick={accept}
                  data-testid="cookie-accept-btn"
                  className="px-5 py-2 rounded-xl text-sm font-semibold bg-[#4DD0E1] text-black hover:bg-[#3bc0d1] transition-colors"
                >
                  Accepteren
                </button>
              </div>
              <button
                onClick={decline}
                className="absolute top-3 right-3 md:hidden text-[#A1A1AA] hover:text-white"
                data-testid="cookie-close-btn"
              >
                <X size={18} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
